import customerAccountsService from 'Assets/js/components/customerAccountsService';
import events from 'Assets/js/components/events';

const triggerWishlistMessage = (type, payload) => {
  const formattedTitle = (payload?.title || '').split('||')[0].trim();
  const title =
    type === 'added' ? 'Item Added To Wishlist' : 'Item Removed From Wishlist';
  const content =
    type === 'added'
      ? `${formattedTitle} has been added to your Wishlist`
      : `${formattedTitle} has been removed from your Wishlist`;

  window.dispatchEvent(
    new CustomEvent('error-toggled', {
      detail: {
        subtitle: '',
        title,
        content
      }
    })
  );
};

const actions = {
  wishlist(context) {
    return context.state.loaded ? context.getters.wishlist : [];
  },
  triggerAddToWishlist(context, payload) {
    if (customerAccountsService.enabled()) {
      customerAccountsService.toggleWishlist(payload.id).then((response) => {
        if (!response) {
          return;
        }

        if (response?.type === 'added') {
          context.commit('addWishlistItem', payload.id);
          events.wishlistAdd(payload.id);
        } else if (response?.type === 'removed') {
          context.commit('removeWishlistItem', payload.id);
          events.wishlistRemove(payload.id);
        }

        if (response?.type) {
          triggerWishlistMessage(response.type, payload);
        }

        if (response?.user) {
          context.commit('setUser', response.user);
          context.commit('setWishlist', response.user.wishlist?.value ?? []);
        }

        if (typeof payload.callback === 'function') {
          payload.callback(response.type);
        }
      });
      return;
    }

    context.getters.userInstance.triggerAddToWishlist(
      payload.id,
      payload.title,
      (response) => {
        if (response) {
          if (response.type === 'added') {
            context.commit('addWishlistItem', payload.id);
          } else if (response.type === 'removed') {
            context.commit('removeWishlistItem', payload.id);
          }

          if (typeof payload.callback === 'function') {
            payload.callback(response.type);
          }

          return response.type;
        }
      }
    );
  }
};

export default actions;
